import { render } from "./OfferingTeam.vue?vue&type=template&id=eb867c7a"
import script from "./OfferingTeam.vue?vue&type=script&lang=js"
export * from "./OfferingTeam.vue?vue&type=script&lang=js"
script.render = render

export default script